module.exports = __webpack_public_path__ + "files/1c33238d1d9913bae313a009584e7ec6.png";